import { cn } from '@workspace/shadcn';

export function Section({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <section
      className={cn(
        'relative z-10 container mx-auto w-full max-w-8xl px-4 py-12 lg:px-6 lg:py-20',
        className,
      )}
    >
      {children}
    </section>
  );
}
